import(/* webpackMode: "eager", webpackExports: ["__esModule","default"] */ "/app/node_modules/next/dist/client/link.js");
;
import(/* webpackMode: "eager", webpackExports: ["FooterImages"] */ "/app/src/components/general/Footer/FooterImages.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["FooterLicenseContent"] */ "/app/src/components/general/Footer/FooterLicenseContent.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["FooterMenu"] */ "/app/src/components/general/Footer/FooterMenu.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["SafeFooterCopyright"] */ "/app/src/components/general/Footer/SafeFooterCopyright.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["ScFooterCopyright","ScFooter","ScFooterItem","ScFooterItemRight","ScFooterImagesGroup","ScFooterItemLeft","ScFooterSocialLinks","ScAppLinks"] */ "/app/src/components/general/Footer/styled.ts");
;
import(/* webpackMode: "eager", webpackExports: ["HeaderDesktop"] */ "/app/src/components/general/Header/HeaderDesktop/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["HeaderMobile"] */ "/app/src/components/general/Header/HeaderMobile/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["TabBar"] */ "/app/src/components/general/TabBar/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["ImageComponent"] */ "/app/src/components/Image/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["SwitchLanguage"] */ "/app/src/components/SwitchLanguage/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["abTestingFunction"] */ "/app/src/helpers/abTesting.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["sendEventToAnalyticsFn"] */ "/app/src/helpers/analytics.ts");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/hooks/estonia.ts");
;
import(/* webpackMode: "eager", webpackExports: ["ClientCommonLayout"] */ "/app/src/layouts/ClientCommonLayout.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["ScServerLayoutContainer"] */ "/app/src/layouts/styled.ts");
;
import(/* webpackMode: "eager" */ "/app/src/modules/common/components/CasinoClockUTC/CasinoClockUTC.tsx");
;
import(/* webpackMode: "eager" */ "/app/src/modules/common/components/FAQ/FAQContainer.tsx");
;
import(/* webpackMode: "eager" */ "/app/src/modules/common/components/FAQ/FAQSection.tsx");
;
import(/* webpackMode: "eager" */ "/app/src/modules/common/components/skeletons/LobbySliderSkeleton.tsx");
;
import(/* webpackMode: "eager" */ "/app/src/modules/common/hooks/useAuthCookies.ts");
;
import(/* webpackMode: "eager" */ "/app/src/modules/common/hooks/useInfoProject.ts");
;
import(/* webpackMode: "eager" */ "/app/src/modules/common/hooks/useLicenseScript.tsx");
;
import(/* webpackMode: "eager" */ "/app/src/modules/common/hooks/useNDBConfirmEmailModals.ts");
;
import(/* webpackMode: "eager" */ "/app/src/modules/deposit/hooks/useABIncreasePrevDep.ts");
;
import(/* webpackMode: "eager" */ "/app/src/modules/deposit/hooks/useErrorsNotifications.tsx");
;
import(/* webpackMode: "eager" */ "/app/src/modules/googleAnalytics/hooks/useConfigGAHook.ts");
;
import(/* webpackMode: "eager" */ "/app/src/modules/localization/hooks/useLanguageChange.ts");
;
import(/* webpackMode: "eager", webpackExports: ["AppLinks"] */ "/app/src/modules/mobileApp/components/AppLinks/index.tsx");
;
import(/* webpackMode: "eager" */ "/app/src/modules/promotions/components/BonanzaPromoDashboardContent/index.tsx");
;
import(/* webpackMode: "eager" */ "/app/src/modules/promotions/components/BonanzaPromoSnackbar/index.tsx");
;
import(/* webpackMode: "eager" */ "/app/src/modules/promotions/components/ClockUTC/index.tsx");
;
import(/* webpackMode: "eager" */ "/app/src/modules/promotions/components/CmsFaq/index.tsx");
;
import(/* webpackMode: "eager" */ "/app/src/modules/promotions/components/CmsHowToParticipate/index.tsx");
;
import(/* webpackMode: "eager" */ "/app/src/modules/promotions/components/FortuneWheelPage/index.tsx");
;
import(/* webpackMode: "eager" */ "/app/src/modules/promotions/components/PromotionsPage/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["useBonanzaPromo"] */ "/app/src/modules/promotions/hooks/useBonanzaPromo.tsx");
;
import(/* webpackMode: "eager" */ "/app/src/modules/promotions/hooks/useDiceRoll.tsx");
;
import(/* webpackMode: "eager" */ "/app/src/modules/promotions/hooks/usePromotionsMenuData.ts");
;
import(/* webpackMode: "eager", webpackExports: ["useServer"] */ "/app/src/modules/server/context/ServerEnvContext.tsx");
;
import(/* webpackMode: "eager" */ "/app/src/store/StoreClient.ts");
;
import(/* webpackMode: "eager", webpackExports: ["ScContainer"] */ "/app/src/styles/common.ts");
;
import(/* webpackMode: "eager" */ "/app/src/theme/images/all.svg");
;
import(/* webpackMode: "eager" */ "/app/src/theme/images/arrowDownGrayIcon.svg");
;
import(/* webpackMode: "eager" */ "/app/src/theme/images/arrowDownIcon.svg");
;
import(/* webpackMode: "eager" */ "/app/src/theme/images/arrowDownSmallIcon.svg");
;
import(/* webpackMode: "eager" */ "/app/src/theme/images/arrowLeftIcon.svg");
;
import(/* webpackMode: "eager" */ "/app/src/theme/images/arrowRightWhiteIcon.svg");
;
import(/* webpackMode: "eager" */ "/app/src/theme/images/arrowUpGrayIcon.svg");
;
import(/* webpackMode: "eager" */ "/app/src/theme/images/basketIcon.svg");
;
import(/* webpackMode: "eager" */ "/app/src/theme/images/betIcon.svg");
;
import(/* webpackMode: "eager" */ "/app/src/theme/images/blueArrowIcon.svg");
;
import(/* webpackMode: "eager" */ "/app/src/theme/images/bonusBuy.svg");
;
import(/* webpackMode: "eager" */ "/app/src/theme/images/bonusTerms/depNumber.svg");
;
import(/* webpackMode: "eager" */ "/app/src/theme/images/bonusTerms/frequency.svg");
;
import(/* webpackMode: "eager" */ "/app/src/theme/images/bonusTerms/fsAmount.svg");
;
import(/* webpackMode: "eager" */ "/app/src/theme/images/bonusTerms/game.svg");
;
import(/* webpackMode: "eager" */ "/app/src/theme/images/bonusTerms/hourglass.svg");
;
import(/* webpackMode: "eager" */ "/app/src/theme/images/bonusTerms/info.svg");
;
import(/* webpackMode: "eager" */ "/app/src/theme/images/bonusTerms/maxBonus.svg");
;
import(/* webpackMode: "eager" */ "/app/src/theme/images/bonusTerms/maxCashout.svg");
;
import(/* webpackMode: "eager" */ "/app/src/theme/images/bonusTerms/maxWinFs.svg");
;
import(/* webpackMode: "eager" */ "/app/src/theme/images/bonusTerms/minDep.svg");
;
import(/* webpackMode: "eager" */ "/app/src/theme/images/bonusTerms/prize.svg");
;
import(/* webpackMode: "eager" */ "/app/src/theme/images/bonusTerms/rtp.svg");
;
import(/* webpackMode: "eager" */ "/app/src/theme/images/bonusTerms/tick.svg");
;
import(/* webpackMode: "eager" */ "/app/src/theme/images/bonusTerms/wager.svg");
;
import(/* webpackMode: "eager" */ "/app/src/theme/images/bonusTerms/wagerDark.svg");
;
import(/* webpackMode: "eager" */ "/app/src/theme/images/btc.svg");
;
import(/* webpackMode: "eager" */ "/app/src/theme/images/burgerIcon.svg");
;
import(/* webpackMode: "eager" */ "/app/src/theme/images/casinoIcon.svg");
;
import(/* webpackMode: "eager" */ "/app/src/theme/images/casual.svg");
;
import(/* webpackMode: "eager" */ "/app/src/theme/images/categoryDefault.svg");
;
import(/* webpackMode: "eager" */ "/app/src/theme/images/checkIcon.svg");
;
import(/* webpackMode: "eager" */ "/app/src/theme/images/clockIcon.svg");
;
import(/* webpackMode: "eager" */ "/app/src/theme/images/closeIcon.svg");
;
import(/* webpackMode: "eager" */ "/app/src/theme/images/crossCircleIcon.svg");
;
import(/* webpackMode: "eager" */ "/app/src/theme/images/crossGrayIcon.svg");
;
import(/* webpackMode: "eager" */ "/app/src/theme/images/crossIcon.svg");
;
import(/* webpackMode: "eager" */ "/app/src/theme/images/crossInCircleIcon.svg");
;
import(/* webpackMode: "eager" */ "/app/src/theme/images/crossWhiteIcon.svg");
;
import(/* webpackMode: "eager" */ "/app/src/theme/images/cup.svg");
;
import(/* webpackMode: "eager" */ "/app/src/theme/images/currencyIcon.svg");
;
import(/* webpackMode: "eager" */ "/app/src/theme/images/dropdownArrow.svg");
;
import(/* webpackMode: "eager" */ "/app/src/theme/images/envelopeIcon.svg");
;
import(/* webpackMode: "eager" */ "/app/src/theme/images/equalitySign.svg");
;
import(/* webpackMode: "eager" */ "/app/src/theme/images/errorIcon.svg");
;
import(/* webpackMode: "eager" */ "/app/src/theme/images/eyeClosedIcon.svg");
;
import(/* webpackMode: "eager" */ "/app/src/theme/images/eyeOpenIcon.svg");
;
import(/* webpackMode: "eager" */ "/app/src/theme/images/globeIcon.svg");
;
import(/* webpackMode: "eager" */ "/app/src/theme/images/grayBetIcon.svg");
;
import(/* webpackMode: "eager" */ "/app/src/theme/images/greyHeartIcon.png");
;
import(/* webpackMode: "eager" */ "/app/src/theme/images/heartFullIcon.svg");
;
import(/* webpackMode: "eager" */ "/app/src/theme/images/heartIcon.svg");
;
import(/* webpackMode: "eager" */ "/app/src/theme/images/heartIconDouble.svg");
;
import(/* webpackMode: "eager" */ "/app/src/theme/images/homeIcon.svg");
;
import(/* webpackMode: "eager" */ "/app/src/theme/images/homeStrokeIcon.svg");
;
import(/* webpackMode: "eager" */ "/app/src/theme/images/infoIcon.svg");
;
import(/* webpackMode: "eager" */ "/app/src/theme/images/infoIconCircle.svg");
;
import(/* webpackMode: "eager" */ "/app/src/theme/images/infoIconTooltip.svg");
;
import(/* webpackMode: "eager" */ "/app/src/theme/images/jackpot.svg");
;
import(/* webpackMode: "eager" */ "/app/src/theme/images/jackpotIcon.png");
;
import(/* webpackMode: "eager" */ "/app/src/theme/images/live.svg");
;
import(/* webpackMode: "eager" */ "/app/src/theme/images/lockIcon.svg");
;
import(/* webpackMode: "eager" */ "/app/src/theme/images/logo.svg");
;
import(/* webpackMode: "eager" */ "/app/src/theme/images/logoMin.svg");
;
import(/* webpackMode: "eager" */ "/app/src/theme/images/lupIcon.svg");
;
import(/* webpackMode: "eager" */ "/app/src/theme/images/lupIcon1.svg");
;
import(/* webpackMode: "eager" */ "/app/src/theme/images/magnifier.svg");
;
import(/* webpackMode: "eager" */ "/app/src/theme/images/magnifierLargeIcon.svg");
;
import(/* webpackMode: "eager" */ "/app/src/theme/images/menuIcon.svg");
;
import(/* webpackMode: "eager" */ "/app/src/theme/images/minusIcon.svg");
;
import(/* webpackMode: "eager" */ "/app/src/theme/images/moneyBag.svg");
;
import(/* webpackMode: "eager" */ "/app/src/theme/images/new.svg");
;
import(/* webpackMode: "eager" */ "/app/src/theme/images/newIcon.png");
;
import(/* webpackMode: "eager" */ "/app/src/theme/images/newNotificationIcon.svg");
;
import(/* webpackMode: "eager" */ "/app/src/theme/images/notificationIcon.svg");
;
import(/* webpackMode: "eager" */ "/app/src/theme/images/notificationWithBadgeIcon.svg");
;
import(/* webpackMode: "eager" */ "/app/src/theme/images/playIcon.svg");
;
import(/* webpackMode: "eager" */ "/app/src/theme/images/plusIcon.svg");
;
import(/* webpackMode: "eager" */ "/app/src/theme/images/plusIconBlack.svg");
;
import(/* webpackMode: "eager" */ "/app/src/theme/images/plusIconBoldWhite.svg");
;
import(/* webpackMode: "eager" */ "/app/src/theme/images/plusIconGrey.svg");
;
import(/* webpackMode: "eager" */ "/app/src/theme/images/presentIcon.svg");
;
import(/* webpackMode: "eager" */ "/app/src/theme/images/presentSmallIcon.svg");
;
import(/* webpackMode: "eager" */ "/app/src/theme/images/prizeIcon1.svg");
;
import(/* webpackMode: "eager" */ "/app/src/theme/images/prizePoolBlackIcon.svg");
;
import(/* webpackMode: "eager" */ "/app/src/theme/images/prizePoolIcon.svg");
;
import(/* webpackMode: "eager" */ "/app/src/theme/images/profile/activeSessionsIcon.svg");
;
import(/* webpackMode: "eager" */ "/app/src/theme/images/profile/addressIcon.svg");
;
import(/* webpackMode: "eager" */ "/app/src/theme/images/profile/arrowSelectIcon.svg");
;
import(/* webpackMode: "eager" */ "/app/src/theme/images/profile/changePasswordIcon.svg");
;
import(/* webpackMode: "eager" */ "/app/src/theme/images/profile/coolingOffIcon.svg");
;
import(/* webpackMode: "eager" */ "/app/src/theme/images/profile/crossIcon.svg");
;
import(/* webpackMode: "eager" */ "/app/src/theme/images/profile/depositHistoryRowIcon.svg");
;
import(/* webpackMode: "eager" */ "/app/src/theme/images/profile/depositLimitsIcon.svg");
;
import(/* webpackMode: "eager" */ "/app/src/theme/images/profile/faileFileUploadIcon.svg");
;
import(/* webpackMode: "eager" */ "/app/src/theme/images/profile/fileUploadIcon.svg");
;
import(/* webpackMode: "eager" */ "/app/src/theme/images/profile/identityIcon.svg");
;
import(/* webpackMode: "eager" */ "/app/src/theme/images/profile/imageIcon.svg");
;
import(/* webpackMode: "eager" */ "/app/src/theme/images/profile/linkBoldIcon.svg");
;
import(/* webpackMode: "eager" */ "/app/src/theme/images/profile/lossLimitsIcon.svg");
;
import(/* webpackMode: "eager" */ "/app/src/theme/images/profile/paymentIcon.svg");
;
import(/* webpackMode: "eager" */ "/app/src/theme/images/profile/pdfIcon.svg");
;
import(/* webpackMode: "eager" */ "/app/src/theme/images/profile/selfExclusionIcon.svg");
;
import(/* webpackMode: "eager" */ "/app/src/theme/images/profile/tooltipIcon.svg");
;
import(/* webpackMode: "eager" */ "/app/src/theme/images/profile/trashIcon.svg");
;
import(/* webpackMode: "eager" */ "/app/src/theme/images/profile/twoFactorIcon.svg");
;
import(/* webpackMode: "eager" */ "/app/src/theme/images/profile/verifyEmailIcon.svg");
;
import(/* webpackMode: "eager" */ "/app/src/theme/images/profile/verifyNotificationIcon.svg");
;
import(/* webpackMode: "eager" */ "/app/src/theme/images/profile/wagerLimitsIcon.svg");
;
import(/* webpackMode: "eager" */ "/app/src/theme/images/profile/withdrawalHistoryRowIcon.svg");
;
import(/* webpackMode: "eager" */ "/app/src/theme/images/profileIcon.svg");
;
import(/* webpackMode: "eager" */ "/app/src/theme/images/providers1Icon.svg");
;
import(/* webpackMode: "eager" */ "/app/src/theme/images/providersIcon.svg");
;
import(/* webpackMode: "eager" */ "/app/src/theme/images/randomizeIcon.svg");
;
import(/* webpackMode: "eager" */ "/app/src/theme/images/searchGrayIcon.svg");
;
import(/* webpackMode: "eager" */ "/app/src/theme/images/searchIcon.svg");
;
import(/* webpackMode: "eager" */ "/app/src/theme/images/slots.svg");
;
import(/* webpackMode: "eager" */ "/app/src/theme/images/spinsIcon.svg");
;
import(/* webpackMode: "eager" */ "/app/src/theme/images/sportsIcon.svg");
;
import(/* webpackMode: "eager" */ "/app/src/theme/images/successCircleIcon.svg");
;
import(/* webpackMode: "eager" */ "/app/src/theme/images/successIcon.svg");
;
import(/* webpackMode: "eager" */ "/app/src/theme/images/supportIcon.svg");
;
import(/* webpackMode: "eager" */ "/app/src/theme/images/tabBarMenu/app.svg");
;
import(/* webpackMode: "eager" */ "/app/src/theme/images/tabBarMenu/casino.svg");
;
import(/* webpackMode: "eager" */ "/app/src/theme/images/tabBarMenu/jackpotTabBar.svg");
;
import(/* webpackMode: "eager" */ "/app/src/theme/images/tabBarMenu/lobby.svg");
;
import(/* webpackMode: "eager" */ "/app/src/theme/images/tabBarMenu/profile.svg");
;
import(/* webpackMode: "eager" */ "/app/src/theme/images/tabBarMenu/promo.svg");
;
import(/* webpackMode: "eager" */ "/app/src/theme/images/tabBarMenu/quest.svg");
;
import(/* webpackMode: "eager" */ "/app/src/theme/images/tabBarMenu/signout.svg");
;
import(/* webpackMode: "eager" */ "/app/src/theme/images/tabBarMenu/sports.svg");
;
import(/* webpackMode: "eager" */ "/app/src/theme/images/tabBarMenu/sportsMobileMenuIcon.svg");
;
import(/* webpackMode: "eager" */ "/app/src/theme/images/tabBarMenu/tournaments.svg");
;
import(/* webpackMode: "eager" */ "/app/src/theme/images/tabBarMenu/vip.svg");
;
import(/* webpackMode: "eager" */ "/app/src/theme/images/table.svg");
;
import(/* webpackMode: "eager" */ "/app/src/theme/images/termsAndConditionsIcon.svg");
;
import(/* webpackMode: "eager" */ "/app/src/theme/images/tickCircleDeclineIcon.svg");
;
import(/* webpackMode: "eager" */ "/app/src/theme/images/tickCircleIcon.svg");
;
import(/* webpackMode: "eager" */ "/app/src/theme/images/tickCircleIcon1.svg");
;
import(/* webpackMode: "eager" */ "/app/src/theme/images/tickIcon.svg");
;
import(/* webpackMode: "eager" */ "/app/src/theme/images/tickIcon1.svg");
;
import(/* webpackMode: "eager" */ "/app/src/theme/images/topicsIcon.svg");
;
import(/* webpackMode: "eager" */ "/app/src/theme/images/trending.svg");
;
import(/* webpackMode: "eager" */ "/app/src/theme/images/trendingIcon.png");
;
import(/* webpackMode: "eager" */ "/app/src/theme/images/wagerIcon.svg");
;
import(/* webpackMode: "eager" */ "/app/src/theme/images/warningIcon.svg");
;
import(/* webpackMode: "eager" */ "/app/src/theme/images/whiteArrowRight.svg");
;
import(/* webpackMode: "eager" */ "/app/src/theme/images/whiteInfoIcon.svg");
;
import(/* webpackMode: "eager" */ "/app/src/theme/images/withdrawalIcon.svg");
